/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import showObject from '../../../../utils/showObject';

const AudioPlayer = ({
  activeLanguage, handlerSetComponents, components, languages, id, reusableComponent, reusableComponentSlugname, slider,
}) => {
  const initialState = {
    type: 'AudioPlayer',
    audioFile: ''
  };
  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);
  const [audioFile, setAudioFile] = useState('');

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    if (reusableComponent) {
      setState(reusableComponent);
      if (!component) handlerSetComponents({ component: { key: reusableComponentSlugname } }, componentIndex);
    } else {
      setIndex(componentIndex);
      if (component) {

        const {
          audioFile: currentAudioFile,
        } = component;

        setState(component);
        setAudioFile(currentAudioFile);

      } else {
        const componentObj = {
          id,
          component: state,
        };

        handlerSetComponents(componentObj, componentIndex);
      }
    }
  }, [components]);

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const construction = {
      type: state.type,
      compId: state.compId || '',
      audioFile,
    }
    handlerSetComponents({ component: construction }, componentIndex);
  }, [
    audioFile,
  ]);

  return (
    <div className="flex justify-start flex-col text-black">
          <div className="w-full">
            <label
              className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              htmlFor="grid-first-name">
              MP3 File Link
            </label>
            <div className="relative">
              <input
                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                type="text"
                onChange={e => setAudioFile(e.target.value)}
                value={audioFile}
              />
            </div>
          </div>
    </div>
  );
};

export default AudioPlayer;
